import {filterMatch} from './common.js';

export function transformData(data, transformers){
    if(!transformers || transformers.length === 0){
        return data;
    }
    transformers.forEach(transformer => {        
        data = applyTransformation(data,transformer);
    });
    return data;
}

function applyTransformation(data, transformer){
    var matchingItems = data;
    if(transformer.filters && transformer.filters.length > 0){
        //find data items that match the transformer filters
        matchingItems = data.filter((record) => {
            return transformer.filters.every((filter) => {
                return filterMatch(record, filter, false);
            });
        });
    }

    //transform the matching items
    matchingItems.forEach((item) => {
        //overwriting
        transformer.overwrite.forEach((overwriting) => {
            item[overwriting.heading] = overwriting.value;
        });
    });
    return data;

    
}